import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import pic1 from "../../../assets/images/email & chat support.jpg";
import { useNavigate } from "react-router-dom";
const EmailChatSupport = () => {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg-gray-100 text-gray-800" style={{ marginTop: "80px" }}>
      {/* Header Section */}

      <motion.header
        className="bg-blue-900 text-white py-16 text-center shadow-lg rounded-lg"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-gradient-to-r from-blue-50 to-indigo-100 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-white">
                  🚀 Revolutionize Your Medical Business with{" "}
                </span>
                <span className="text-blue-600"> Email and Chat Support!</span>
              </h1>
              <p className="text-white mb-4" style={{ fontWeight: "bold" }}>
                Expert BPO Solutions from Right On Time Services
              </p>
              <p className="text-white mb-8">
                As a trusted leader in business process outsourcing (BPO) for
                the medical industry, Right On Time Services offers unparalleled
                email and chat support designed to improve patient communication
                and streamline your operations.
              </p>
              <button
                onClick={() => navigate("/bookmeeting")}
                style={{ color: "black" }}
                className="bg-white text-blue-700 px-6 py-3 font-bold rounded-full hover:bg-blue-100 transition"
              >
                Meet Us
              </button>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Importance of Email and Chat Support */}
      <section className="bg-white py-16 px-4 md:px-12">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {/* Left Side - Centered Content */}
          <div className="flex flex-col justify-center items-center text-left">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              💬 The Power of Email and Chat Support
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              <strong>Why It Matters for Medical Businesses</strong>
            </p>
            <p className="text-gray-700 mb-8 max-w-xl">
              In a world that demands instant answers, email and chat support
              have become essential for seamless communication in the healthcare
              industry. These services help:
            </p>

            <div className="text-left space-y-6 max-w-xl">
              <div className="flex items-start gap-3">
                <span className="text-blue-600 text-xl">🕒</span>
                <p className="text-gray-700">
                  Address patient concerns in real time, ensuring quicker
                  responses to urgent inquiries
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-green-600 text-xl">🏥</span>
                <p className="text-gray-700">
                  Provide continuous support, making patient care more efficient
                  and personalized
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-purple-600 text-xl">💬</span>
                <p className="text-gray-700">
                  Improve accessibility for patients who prefer written
                  communication
                </p>
              </div>
            </div>

            <p className="mt-4 text-gray-800 font-medium max-w-xl">
              Our email and chat support services are critical in ensuring your
              medical business runs smoothly and your patients are well cared
              for.
            </p>
          </div>

          {/* Right Side - Image */}
          <div className="flex justify-center items-center">
            <img
              src={pic1}
              alt="Email and Chat Support"
              className="w-auto h-auto max-h-[400px] object-contain rounded-xl"
            />
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="py-16 bg-gray-100" data-aos="fade-up">
        <div className="text-center mb-4">
          <h2 className="text-3xl font-bold text-blue-900">
            🌐 Our Email and Chat Support Services
          </h2>
          <p className="mt-4">
            We offer a range of customized email and chat support services
            designed to meet the unique needs of healthcare providers:
          </p>
        </div>
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 px-8"
          style={{ marginTop: "30px" }}
        >
          <motion.div
            className="p-6 bg-white rounded-lg shadow-md"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <h3 className="text-xl font-bold text-blue-900">
              24/7 Availability
            </h3>
            <p className="mt-2">
              Our agents are available around the clock to ensure timely
              assistance for your patients, no matter the time of day.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-md"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <h3 className="text-xl font-bold text-blue-900">
              Multilingual Support
            </h3>
            <p className="mt-2">
              Reach a wider audience by offering support in multiple languages,
              enhancing patient satisfaction.
            </p>
          </motion.div>
          <motion.div
            className="p-6 bg-white rounded-lg shadow-md"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <h3 className="text-xl font-bold text-blue-900">
              Personalized Responses
            </h3>
            <p className="mt-2">
              Each inquiry is met with a tailored response, ensuring a more
              personal, thoughtful experience for every patient.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Our Outbound Call Services */}
      <section className="py-16 text-center bg-white" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900">
          🏅 Benefits of Outsourcing Email and Chat Support
        </h2>
        <p className="mt-4">
          Outsourcing your email and chat support to Right On Time Services
          offers many advantages for medical businesses:
        </p>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-gray-100" data-aos="fade-up">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6 px-8">
          {[
            {
              title: "✅ Cost Savings",
              description:
                "Save on the overhead costs of maintaining an in-house support team while benefiting from our expert services.",
            },
            {
              title: "✅ Increased Efficiency",
              description:
                "Our dedicated team ensures prompt replies and faster resolution, increasing your operational effectiveness.",
            },
            {
              title: "✅ Improved Customer Satisfaction",
              description:
                " Timely, professional support results in more satisfied patients, leading to better referrals and positive reviews.",
            },
          ].map((service, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              className="p-6 bg-white rounded-lg shadow-md"
              transition={{ type: "spring", stiffness: 300 }}
            >
              <h3 className="text-xl font-bold text-blue-900">
                {service.title}
              </h3>
              <p className="mt-2 text-gray-700">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Activities of Email and Chat Support */}
      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section className="py-16 bg-gray-100 text-center" data-aos="fade-up">
          <h2 className="text-3xl font-bold text-blue-900 mb-6">
            🛠️ What We Handle: Email and Chat Support Activities
          </h2>
          <p className="mt-4">
            Our support team handles a wide array of essential functions,
            including:
          </p>
          <div className="mt-4 grid md:grid-cols-2 lg:grid-cols-3 gap-6 px-8 max-w-6xl mx-auto">
            <div className="p-6 bg-white rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-blue-900">
                Managing Inquiries:
              </h3>
              <p className="mt-2">
                Whether it's about appointments, billing, or general
                information, our team addresses patient inquiries with care and
                professionalism.
              </p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-blue-900">
                Resolving Issues
              </h3>
              <p className="mt-2">
                We tackle everything from technical difficulties to patient
                complaints, ensuring smooth operations for your practice.
              </p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-blue-900">
                Providing Information
              </h3>
              <p className="mt-2">
                We keep your patients informed by providing accurate details
                about your services, policies, and procedures.
              </p>
            </div>
          </div>
        </section>
      </motion.div>

      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section className="bg-gray-50 py-16 px-6 md:px-20">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              💼 Our Dedicated Team
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Expert Support Agents Committed to Excellence
            </p>
            <p className="text-gray-700 mb-10">
              At Right On Time Services, we recruit only the best talent to
              provide exceptional email and chat support. Our agents undergo:
            </p>

            <div className="text-left space-y-6 max-w-3xl mx-auto">
              <div className="flex items-start gap-3">
                <span className="text-blue-600 text-xl font-semibold">📘</span>
                <p className="text-gray-700">
                  <strong>Rigorous Training:</strong> Continuous education
                  ensures they stay ahead of industry trends and technological
                  advancements.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-green-600 text-xl font-semibold">💡</span>
                <p className="text-gray-700">
                  <strong>Industry Expertise:</strong> Equipped with the
                  knowledge to address the unique needs of the healthcare
                  sector.
                </p>
              </div>
            </div>

            <p className="mt-10 text-gray-800 font-medium">
              Our commitment to hiring top-tier professionals means your
              patients receive the best support, every time.
            </p>
          </div>
        </section>
      </motion.div>

      <motion.div
        className="p-6 bg-white rounded-lg transition duration-300"
        data-aos="fade-up"
      >
        <section className="bg-blue-50 py-16 px-6 md:px-20">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              🏆 Transform Your Medical Consultancy with Expert Support
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              Choose Right On Time Services for Unmatched Email and Chat Support
            </p>
            <p className="text-gray-700 mb-6">
              Ready to elevate your medical business with seamless communication
              solutions? Partner with Right On Time Services and transform the
              way you connect with your patients.
            </p>
            <p className="text-gray-800 font-medium mb-10">
              📩 Contact us today to learn how we can help you deliver
              outstanding patient care with expert email and chat support!
            </p>
          </div>
        </section>
      </motion.div>
      {/* Call to Action */}
      <motion.section
        data-aos="fade-up"
        className="py-16 text-center bg-white  rounded-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h2 className="text-3xl font-bold text-blue-900">
          🚀 READY TO START YOUR PROJECT?
        </h2>
        <p className="text-gray-700 mt-4">
          Let’s Start Together — Your journey to improving patient communication
          and operational efficiency begins now.
        </p>
        <button
          onClick={() => navigate("/bookmeeting")}
          className="mt-4 px-6 py-3 bg-blue-900 text-white font-bold rounded-lg shadow-lg hover:shadow-2xl hover:bg-blue-700 transition duration-300"
        >
          Contact Us
        </button>
      </motion.section>
    </div>
  );
};

export default EmailChatSupport;
